<template>
	<div>
		<div class="row">
			<div class="col-8 mb-4">
				<h1 class="float-left" v-if="isNew && !component.id">{{ $t("add-component") }}</h1>
				<h1 class="float-left" v-else-if="loaded">
					{{ component.title }}
				</h1>
				<div class="skeleton midnight h32 w-half" v-else></div>
			</div>
			<div class="col-4 mb-4">
				<button class="btn btn-primary float-right ml-4 mb-1" @click="finishEditing" v-if="editing"
                :disabled="!component.title ">
					{{ $t("save") }}
				</button>
				<button class="btn btn-primary float-right" @click="startEditing" v-else>
					{{ $t("edit") }}
				</button>
				<button class="btn btn-outline-danger float-right" @click="editing = false" v-if="editing && component.id">{{ $t("cancel") }}</button>
			</div>
		</div>
		<div class="row" v-if="error">
			<div class="col-12">
				<b-alert variant="danger" show>{{ error }}</b-alert>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-12">
				<TextInput
					:label="$t('title')"
					v-model="component.title"
					v-if="editing"
				/>
               <template v-else-if="loaded">
                    <label class="font-bold">{{ $t("title") }}</label>
                    <p class="mb-0">
                        {{ component.title }}
                    </p>
               </template>
				<div class="skeleton midnight h16 w-half" v-else></div>
			</div>
		</div>
        <div class="row" v-if="!editing">
            <div class="col-12">
                <h2>{{  $t('nodes')}}</h2>
                <Table
                :loading="!loaded"
                :submitting="submitting"
                :cols="[
                    { key: 'path', heading: $t('path'), size: 12 }
                ]"
                :data="filteredNodes ? filteredNodes : nodes"
                breakpoint="md"
                :filters="{
                    ...filters,
                    page: filters.page,
                    page_size: filters.page_size,
                }"
                :searchable="false"
                :scrollPaginate="true"
                @refresh="refresh"
                @selectItem="node => $router.push(`/curriculum-mapping/node/${node.id}/detail`)">
                <template v-slot:header>
                    <NodeDrilldownSearch
                        v-if="loaded"
                        @filtered-nodes="handleFilteredNodes"
                        view="component"
                        :availableNodes="nodes"
                    />
                </template>
                </Table>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <h2>{{  $t('nodes')}}</h2>
                <div class="clearfix my-2">
                </div>
                <NodeSelector
                    v-model="nodes"
                    :loading="!loaded"
                    :availableNodes="allNodes"
                    :canEdit="editing"
                />
            </div>
        </div>
	</div>
</template>

<script>
import NodeSelector from "src/components/CurriculumMapping/NodeSelector.vue";
import Table from 'src/components/Table/Table.vue';
import NodeDrilldownSearch from "src/components/CurriculumMapping/NodeDrilldownSearch.vue";
import CurriculumMap from 'src/modules/curriculummap.js'

export default {
	components: {
       NodeSelector,
       Table,
       NodeDrilldownSearch
	},
	data: function () {
		return {
			error: null,
			loaded: false,
			editing: false,
            component: {
            	id: null,
            	title: null,
            },
            nodes:[],
            submitting: false,
            filters: {
				page: 1,
				page_size: 30,
				total: 0,
				search: '',
			},
            allNodes: [],
            filteredNodes:null
		};
	},
    created(){

    },
	mounted() {
        // We call the Curriculum Map class
        this.curriculummap = new CurriculumMap(this.$route.params.id);

        if (this.isNew) {
            this.loaded = true;
            this.startEditing();
            this.curriculummap.getNodes({ path_in_string: true }).then((res) => {
                this.allNodes = res;
            });
        } else {
            this.curriculummap.getNodes({ path_in_string: true }).then((res) => {
                this.allNodes = res;
                this.getComponent();
            });
        }
	},
	methods: {
        getComponent() {
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/component/get`,{
                method: "post",
                data: {
                    id: this.$route.params["component_id"]
                }
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    this.component = res.result;
                    this.nodes = this.addPathToNodes(res.result.curriculummap)
            
				} else {
					this.$log.error.call(this, res.status);
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			}).finally(()=>{
                this.loaded = true;
            });
        },
        addPathToNodes(array){
            // We take an array and add the paths in allNodes obtained from getNodes

            // First, we create a map of the result array objects by id
            const nodesMap = new Map(
                array.map(obj => [obj.id, obj])
            );

            // Then, we add additional keys and filter out objects not shared by both arrays
            array = this.allNodes
                .map(obj => {
                    const additionalInfo = nodesMap.get(obj.id);
                    return additionalInfo ? { ...obj, ...additionalInfo } : null;
                })
                .filter(obj => obj !== null);

            return array;
        },
		finishEditing () {
            this.$store.commit("showBlockingSpinner");
			this.saveComponent();
		},
        startEditing() {
            this.editing = true;
        },
        saveComponent() {
			this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/component/save`, {
				method: "post",
				data: {
                    id: this.component.id,
                    title: this.component.title,
                    nodes: this.nodes
                }
			})
			.then((res) => {
            	this.$store.commit("hideBlockingSpinner");
				if (res.status === "SUCCESS") {

					this.error = null;
					this.editing = false;
                    this.loaded = true;

                    this.component = res.result;
                    this.curriculummap.getNodes({ path_in_string: true }).then((res) => {
                        this.allNodes = res
                    })
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = "There was a problem saving the topic.";
					}
				}
			}).catch((error) => {
            	this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
				this.error = "There was a problem saving the topic.";
			});
        },
        refresh(filters) {
			this.filters = { ...this.filters, ...filters }
			this.getComponent();
		},
        handleFilteredNodes(val) {
            this.filteredNodes = val;
            console.log(val)
            return val;
        }
	},
	computed: {
		isNew: function () {
			return !this.$route.params["component_id"];
		},
	},
};
</script>


